
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commande-en-ligne/[idRestaurant]/carte",
      function () {
        return require("private-next-pages/commande-en-ligne/[idRestaurant]/carte.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commande-en-ligne/[idRestaurant]/carte"])
      });
    }
  